import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { createUseStyles } from 'react-jss';

function ProductImagePlaceholder({ absolute }) {
  const classes = useStyles({ absolute });

  return (
    <div className={classes.container}>
      <Spinner animation="border" />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    position: ({ absolute }) => (absolute ? 'absolute' : 'relative'),
    display: 'flex',
    color: 'white',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    touchAction: 'pan-x pan-y',
  },
});

export { ProductImagePlaceholder };
